import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLmmsComponent } from './simple-icons-lmms.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLmmsComponent ],
    exports:      [ SimpleIconsLmmsComponent ],
    bootstrap:    []
})
export class SimpleIconsLmmsModule {}
